import { createVuetify, IconProps, IconSet } from 'vuetify';
import { h } from 'vue';
import { mdi } from 'vuetify/iconsets/mdi';
import { Ripple } from 'vuetify/directives';
import * as components from 'vuetify/components';
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n';
import { I18n, useI18n } from 'vue-i18n';
import 'vuetify/styles';

import { DISPLAY_BREAKPOINT_XS } from '@/config/config';
import { getIcons, getIconsAliases, getTheme } from '@/themes/theme';
import i18n from '../i18n';

declare const __CI__: boolean;

const icons = getIcons();
const aliases = getIconsAliases();

const customSVGs: IconSet = {
  component: (props: IconProps) => h(icons[props.icon as string]),
};

const vuetify = createVuetify({
  directives: {
    Ripple, // to show action from a user - click on a button etc.
  },
  components: {
    ...components,
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
      custom: customSVGs,
    },
  },
  display: {
    mobileBreakpoint: DISPLAY_BREAKPOINT_XS,
  },
  theme: {
    variations: {
      colors: ['primary', 'success', 'error', 'info', 'warning', 'contrast'],
      lighten: 5,
      darken: 5,
    },
    ...getTheme(),
  },
  locale: {
    adapter: createVueI18nAdapter({ i18n: i18n as I18n, useI18n }),
  },
  defaults: {
    VMenu: __CI__ ? { transition: false, openDelay: 0, closeDelay: 0 } : {},
    VDialog: __CI__ ? { transition: false, openDelay: 0, closeDelay: 0 } : {},
  },
});

export default vuetify;
